module.exports = __webpack_public_path__ + "static/media/mcgill-university-logo-png-transparent-cropped.46394929.png";